/* unplugin-vue-components disabled */import { render } from "./userSheet.vue?vue&type=template&id=977618f0&scoped=true&ts=true"
import script from "./userSheet.vue?vue&type=script&lang=ts"
export * from "./userSheet.vue?vue&type=script&lang=ts"

import "./userSheet.vue?vue&type=style&index=0&id=977618f0&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-977618f0"],['__file',"src/baseui/userSheet/userSheet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "977618f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('977618f0', __exports__)) {
    console.log('reload')
    api.reload('977618f0', __exports__)
  }
  
  module.hot.accept("./userSheet.vue?vue&type=template&id=977618f0&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('977618f0', render)
  })

}


export default __exports__